import { render, staticRenderFns } from "./otherContractCreation.vue?vue&type=template&id=654cc080"
import script from "./otherContractCreation.vue?vue&type=script&lang=js"
export * from "./otherContractCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports